/**
 * Rillion Prime API v1.0
 * A REST API endpoint for Role operations.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface RoleEntity {
  role?: string | null;
  name?: string | null;
  userGroup?: string | null;
  active?: boolean;
  includableInFlow?: boolean;
  roleAdministrator?: string | null;
  roleSupervisor?: string | null;
  powerRole?: string | null;
  reminderArrival?: number;
  reminderDueDate?: number;
  reminderSupervisor?: number;
  forwardSupervisor?: number;
  authorizationAmount?: number;
  authorizationOutstandingAmountExceed?: number;
  authorizationOutstandingAmountBelow?: number;
  authorizationOutstandingAmountPercentExceed?: number;
  authorizationOutstandingAmountPercentBelow?: number;
  permissionGroupBitCode?: number;
  selectCompany?: string | null;
  selectAccount?: string | null;
  selectObject1?: string | null;
  selectObject2?: string | null;
  selectObject3?: string | null;
  selectObject4?: string | null;
  selectObject5?: string | null;
  selectObject6?: string | null;
  selectObject7?: string | null;
  selectObject8?: string | null;
  defaultCompany?: string | null;
  defaultObject1Id?: number | null;
  defaultObject2Id?: number | null;
  defaultObject3Id?: number | null;
  defaultObject4Id?: number | null;
  defaultObject5Id?: number | null;
  defaultObject6Id?: number | null;
  defaultObject7Id?: number | null;
  defaultObject8Id?: number | null;
  flowProposalId?: number | null;
  group1?: string | null;
  group2?: string | null;
  group3?: string | null;
  chTime?: string;
  chUser?: string | null;
  defaultAddressId?: number | null;
  selectCommodity?: string | null;
  selectExpenseType?: string | null;
  newAuthorizationAmount?: number;
  newAuthorizationAmountRole?: string | null;
  newAuthorizationAmountUser?: string | null;
  newAuthorizationAmountDatetime?: string | null;
  reminderImmidiateBitCode?: number;
}
